import './santabarb/style';
import FormStructure from './santabarb/form_structure';

export default FormStructure;